import { Components, Theme } from '@mui/material/styles';
import { MuiButton } from './Button';
import { MuiTextField } from './TextField';
import { MuiCard, MuiCardContent } from './Card';
import { MuiPaper } from './Paper';
import { MuiAppBar } from './AppBar';
import { MuiTab, MuiTabs } from './Tabs';
import { MuiChip } from './Chip';
import { MuiDivider } from './Divider';
import { MuiSwitch } from './Switch';
import { MuiAvatar } from './Avatar';
import {
  MuiFormControl,
  MuiFormHelperText,
  MuiInputLabel,
} from './FormControl';
import { MuiInputBase, MuiOutlinedInput, MuiFilledInput } from './Input';
import { MuiSelect } from './Select';
import { MuiIconButton } from './IconButton';
import { MuiDataGrid } from './DataGrid';
import { MuiListItemButton } from './ListItemButton';
import { MuiCssBaseline } from './CssBaseline';

// Combine all component overrides (Dialog overrides are added dynamically in ThemeProvider)
export const components: Components<Theme> = {
  MuiBackdrop: {
    styleOverrides: {
      root: ({ theme, ownerState }) => ({
        backgroundColor: ownerState.invisible
          ? 'transparent'
          : theme.palette.studio.surfaces.backdrop,
      }),
    },
  },
  MuiMenu: {
    styleOverrides: {
      paper: ({ theme }) => ({
        border: `1px solid ${theme.palette.studio.borders.control}`,
        boxShadow: theme.palette.studio.shadows.menu,
        backgroundImage: 'none',
      }),
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: ({ theme }) => ({
        backgroundColor: theme.palette.background.paper,
        backgroundImage: 'none',
        borderColor: theme.palette.divider,
      }),
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderColor: theme.palette.divider,
        fontSize: 13,
      }),
      head: ({ theme }) => ({
        color: theme.palette.text.secondary,
        fontWeight: 600,
        backgroundColor: theme.palette.studio.surfaces.fillSubtle,
      }),
    },
  },
  MuiCssBaseline,
  MuiButton,
  MuiTextField,
  MuiCard,
  MuiCardContent,
  MuiPaper,
  MuiAppBar,
  MuiTab,
  MuiTabs,
  MuiChip,
  MuiDivider,
  MuiSwitch,
  MuiAvatar,
  MuiFormControl,
  MuiInputLabel,
  MuiFormHelperText,
  MuiInputBase,
  MuiOutlinedInput,
  MuiFilledInput,
  MuiSelect,
  MuiIconButton,
  MuiDataGrid,
  MuiListItemButton,
};
